'use client';

import React, { ReactNode } from 'react';
import { ChevronUpIcon, ChevronDownIcon } from 'lucide-react';
import { Root, Trigger, Content, CollapsibleProps } from '@radix-ui/react-collapsible';
import clsx from 'clsx';
import { Box } from '../../../../../wag-react/next-components/box';
const TriggerButton = ({
  open
}: {
  open: boolean;
}) => <Box as="span" type="button" cursor="pointer" border={open ? '1px solid #fff' : '1px solid #272727'} bg={open ? '#272727' : 'transparent'} borderRadius="50px" width="22px" height="22px" display="inline-flex" alignItems="center" justifyContent="center" position="relative" data-sentry-element="Box" data-sentry-component="TriggerButton" data-sentry-source-file="WalkerServiceCollapsible.tsx">
    {open ? <ChevronUpIcon className="h-4 w-4 text-white absolute" /> : <ChevronDownIcon className="h-4 w-4 text-[#272727] absolute" />}

  </Box>;
const TriggerButtonAddon = ({
  open
}: {
  open: boolean;
}) => <Box as="span" type="button" cursor="pointer" border="none" bg="transparent" width="22px" height="22px" display="inline-flex" alignItems="center" justifyContent="center" position="relative" data-sentry-element="Box" data-sentry-component="TriggerButtonAddon" data-sentry-source-file="WalkerServiceCollapsible.tsx">
    {open ? <ChevronUpIcon className="h-4 w-4 text-[#272727] absolute" /> : <ChevronDownIcon className="h-4 w-4 text-[#272727] absolute" />}

  </Box>;
type Props = {
  rootClassName?: string;
  rootProps?: CollapsibleProps;
  title: ReactNode;
  content: ReactNode;
  addons?: boolean;
};
const WalkerServiceCollapsible = ({
  rootClassName,
  rootProps = {
    defaultOpen: true
  },
  title,
  content,
  addons = false
}: Props) => {
  const [open, setOpen] = React.useState(false);
  return <Root defaultOpen={rootProps.defaultOpen} className={clsx('w-full bg-transparent', rootClassName)} open={open} onOpenChange={setOpen} data-sentry-element="Root" data-sentry-component="WalkerServiceCollapsible" data-sentry-source-file="WalkerServiceCollapsible.tsx">
      <Box display="flex" alignItems="center" width="100%" justifyContent="space-between" border={addons ? '1px solid #E5E5E5' : 'none'} borderRadius={addons ? '12px' : '0'} overflow="hidden" borderBottom="1px solid #E5E5E5" data-sentry-element="Box" data-sentry-source-file="WalkerServiceCollapsible.tsx">
        <Trigger asChild data-sentry-element="Trigger" data-sentry-source-file="WalkerServiceCollapsible.tsx">
          <Box as="button" display="flex" alignItems="center" width="100%" justifyContent="space-between" borderBottom={addons ? 'none' : '1px solid #D9D9D9'} border="none" bg={addons ? 'white' : 'transparent'} cursor="pointer" data-sentry-element="Box" data-sentry-source-file="WalkerServiceCollapsible.tsx">
            {title}
            {addons ? <TriggerButtonAddon open={open} /> : <TriggerButton open={open} />}
          </Box>
        </Trigger>
      </Box>

      <Content className="data-[state=open]:animate-slideDown data-[state=closed]:animate-slideUp" data-sentry-element="Content" data-sentry-source-file="WalkerServiceCollapsible.tsx">
        {content}
      </Content>
    </Root>;
};
export default WalkerServiceCollapsible;